export default "__VITE_ASSET__DneT9rEC__"